// extracted by mini-css-extract-plugin
export default {"card":"Category_card__tUa7v"};